import { render, staticRenderFns } from "./AddLocationPhysical.vue?vue&type=template&id=29fbf090"
import script from "./AddLocationPhysical.vue?vue&type=script&lang=js"
export * from "./AddLocationPhysical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports